import React from "react";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import HomePage from "./pages/HomePage";
import NotFound from "./NotFound";
import {AboutPage} from "./pages/AboutPage";
import ScrollToTop from "./components/ScrollToTop";
import WaitlistPage from "./pages/WaitlistPage";
import { FAQPage } from "./pages/FAQPage";
import { ContactPage } from "./pages/ContactPage";
import UnderConstructionPage from "./pages/UnderConstructionPage";
import { ProtectedRoute } from "./ProtectedRoute";
import PlatformMainPage from "./platform/pages/PlatformMainPage";
import { AuthProvider } from "./auth";
import UserProfilePage from "./platform/pages/UserProfilePage";
import TodaysSessionPage from "./platform/pages/TodaysSessionsPage";
import TestPage from "./platform/pages/TestPage"
import EditMyPlanPage from "./platform/pages/EditMyPlanPage";
import CustomDatePage from "./platform/pages/CustomDatePage";
import MyExercisesPage from "./platform/pages/MyExercisesPage";
import MyHistoryPage from "./platform/pages/MyHistoryPage";
import UserNotificationsPage from "./platform/pages/UserNotificationsPage";
import UnknownExercisesPage from "./platform/pages/UnknownExercisesPage";
import { Session } from "inspector";
import SessionPage from "./platform/pages/SessionPage";
import TermsOfService from "./pages/TermsOfService"
import PhysioPage from "./pages/PhysioPage";
import PhysioWaitlistPage from "./pages/PhysioWaitlistPage";
import FormPage from "./platform/pages/FormPage";
import TestForm from "./platform/pages/TestForm";
import HealthDataConsentPage from "./platform/pages/HealthDataConsentPage"
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import RecoveryPageRedirect from "./RecoveryPageRedirect";
const App: React.FC = () => (
  <AuthProvider>
    <BrowserRouter>
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Navigate to="/en" replace />} />
        <Route path="/:lang" element={<HomePage />} />
        <Route path="/:lang/about-us" element={<AboutPage />} />
        <Route path="/:lang/sign-up" element={<WaitlistPage/>}/>
        <Route path="/:lang/sign-in" element={<WaitlistPage/>}/> /* CHANGE LATER WHEN DATABASE IS CREATED */
        <Route path="/:lang/faqs" element={<FAQPage/>}/>
        <Route path="/:lang/contact" element={<ContactPage/>}/>
        <Route path="/:lang/terms-of-service" element={<TermsOfService/>}/>
        <Route path="/:lang/*" element={<NotFound />} />
        <Route path="/:lang/pricing" element={<UnderConstructionPage/>} />
        <Route path="/:lang/subscriptions" element={<UnderConstructionPage/>} />
        <Route path="/:lang/help-center" element={<UnderConstructionPage/>} />
        <Route path="/:lang/privacy-policy" element={<PrivacyPolicyPage/>} />


        <Route path="/:lang/test-page" element={<NotFound/>} />


        <Route path="/:lang/physios" element={<PhysioPage />} />
        <Route path="/:lang/pricing-physios" element={<UnderConstructionPage/>} />
        <Route path="/:lang/waitlist-physios" element={<PhysioWaitlistPage/>} />

        <Route path="/:lang/forgot-password" element={<RecoveryPageRedirect />}/>
        <Route path="/:lang/reset-password" element={<RecoveryPageRedirect />}/>

          <Route element={<ProtectedRoute/>}> {/*Remove before running npm run build!!!!!!!!!!!!!!!!*/}
          {/*//~Here are all the paths in the platform :) */}
          

            <Route path="/:lang/platform" element={<PlatformMainPage/>}/>
            <Route path="/:lang/platform/form" element={<FormPage/>}/>
            <Route path="/:lang/platform/health_consent" element={<HealthDataConsentPage/>}/>
            <Route path="/:lang/platform/user-profile" element={<UserProfilePage/>}/>
            <Route path="/:lang/platform/todays-sessions" element={<TodaysSessionPage/>}/>
            <Route path="/:lang/platform/todays-sessions/:sessionId" element={<SessionPage />} />

            <Route path="/:lang/platform/sessions" element={<CustomDatePage/>}/>
            <Route path="/:lang/platform/sessions/:sessionId" element={<SessionPage/>}/>
            <Route path="/:lang/platform/edit-plan" element={<EditMyPlanPage/>}/>
            <Route path="/:lang/platform/exercises" element={<MyExercisesPage/>}/>
            <Route path="/:lang/platform/history" element={<MyHistoryPage/>}/>
            <Route path="/:lang/platform/notifications" element={<UserNotificationsPage/>}/>
            <Route path="/:lang/platform/unknown-exercises" element={<UnknownExercisesPage/>}/>

          </Route>


      </Routes>
    </BrowserRouter>
  </AuthProvider>
);

export default App;
